export const lang = {
  'zh-cn': {
    'title': '领取神功，铸炼超凡',
    'keyWords': '领取神功，铸炼超凡',
    'description': '领取神功，铸炼超凡',
    'website': '进入官网',
    'download': '下载游戏',
    'menuTab1': '领取神功',
    'menuTab2': '小队集结',
    'menuTab3': '道具抽取',
    'activityRule': '活动规则',
    'slogan': '领取神功 铸炼超凡',
    'time': '活动时间：2023.09.04 0:00 ～ 2023.09.30 23:59（UTC）',
    'login': '【登录】',
    'logout': '切换账号',
    'bind': '【绑定角色】',
    'bookName1': '太极拳',
    'bookName2': '达摩剑',
    'bookName3': '易筋经',
    'bookName4': '纯阳剑',
    'bookName5': '金钟罩',
    'bookName6': '斩魔剑',
    'bookName7': '分筋错骨手',
    'bookName8': '螳螂爪',
    'bookName9': '鹰爪功',
    'bookName10': '八卦刀',
    'bookName11': '风火棍',
    'bookName12': '大雁功',
    'bookIntroduction1': '「阴阳相生，变化无穷」',
    'bookIntroduction2': '「心无杂念，禅入剑式」',
    'bookIntroduction3': '「改变筋骨，打通经络」',
    'bookIntroduction4': '「以八卦自然之象，出五行变化之数」',
    'bookIntroduction5': '「拒坚抗锐，如罩金钟」',
    'bookIntroduction6': '「掌可代刃，砍石分铁」',
    'bookIntroduction7': '「化打合一，控敌关节」',
    'bookIntroduction8': '「螳螂斫物，柔中带刚」',
    'bookIntroduction9': '「指如鹰爪，洞胸入腑」',
    'bookIntroduction10': '「刀如游龙，滔滔不绝」',
    'bookIntroduction11': '「吞吐沉浮，刺心戮喉」',
    'bookIntroduction12': '「缓急相应，强弱相兼」',
    'bookTag1': '武当',
    'bookTag2': '少林',
    'bookTag3': '昆仑',
    'bookPageInfo': '\${page1} 部<br>\${page2} 章<br>\${page3} 节',
    'weaponName1': '拐',
    'weaponName2': '锏',
    'weaponName3': '斧',
    'weaponName4': '戟',
    'weaponName5': '刀',
    'weaponName6': '木人桩',
    'weaponName7': '双截棍',
    'weaponName8': '枪',
    'weaponName9': '锤',
    'weaponName10': '钺',
    'weaponName11': '飞刀',
    'weaponName12': '弓',
    'weaponName13': '钩',
    'weaponName14': '狼牙棒',
    'weaponName15': '蛇矛',
    'weaponName16': '八斩刀',
    'surplusBookChance': '剩余抽取次数：',
    'lotteryBook': '抽取功法',
    'getMore': '获取更多',
    'getMoreTip': '参与集结活动，可抽取更多功法',
    'partTitle1': '定制功法书页',
    'partTitle2': '小队集结',
    'partTitle3': '道具抽取',
    'partTitle4': '下载「Puzzles & Survival」体验更多玩法',
    'saveShareText': '保存并分享',
    'tabText1': '功法',
    'tabText2': '书页',
    'tabText3': '英雄',
    'tabText4': '武器',
    'myTeam': '我的小队：',
    'teamState1': '尚未加入',
    'teamState2': '已加入 \${teamNum} 人',
    'teamState3': '集结成功！',
    'createTeam': '创建小队',
    'addTeam': '加入小队',
    'cipherInputTip': '输入集结暗号即可加入小队',
    'cipherLabel': '集结暗号：',
    'linkLabel': '集结链接：',
    'goInvite': '去邀请',
    'copyText': '复制',
    'concludeTip': '您仍可以继续邀请更多指挥官',
    'concludeLabel': '集结成功奖励',
    'getState1': '未达成',
    'getState2': '领取',
    'getState3': '已领取',
    'getState4': '可重复达成',
    'seeAward': '查看奖励',
    'awardBag': '奖励背包',
    'lotteryText': '抽奖',
    'surplusSkinChance': '当前剩余抽奖次数：',
    'awardName1': '皮肤碎片*10',
    'awardName2': '强化选择补给箱*5',
    'awardName3': '升星选择补给箱*5',
    'awardName4': '精密升星选择补给箱*3',
    'awardName5': '钻石*100',
    'awardName6': '血清1000',
    'awardName7': '加速10分钟*3',
    'awardName8': '食物10K',
    'awardName9': '木材10K',
    'awardName10': '钢材2K',
    'awardName11': '汽油500',
    'popupShareTitle': '分享神功',
    'popupShareTip': '您尚未加入小队，分享后可能无法获得奖励',
    'popupShareTipBtn1': '【创建小队】',
    'popupShareTipBtn2': '【去加入】',
    'saveImg': '保存图片',
    'copyShare': '复制去分享',
    'copyShareTip': '已为您复制邀请信息，去社群邀请更多指挥官加入小队以获得更多奖励吧',
    'copyShareText': '和我一起领取神功，加入我的功夫小队吧（暗号：\${cipher}）；点击领取神功：',
    'taskText1': '领取专属功法：',
    'taskText2': '分享神功：',
    'taskText3': '每成功邀请1位指挥官：',
    'taskText4': '小队人数达到2人：',
    'taskText5': '小队人数达到3人：',
    'taskText6': '小队人数达到4人：',
    'taskAward1': '抽取机会*2',
    'taskAward2': '100钻石',
    'taskAward3': '抽取机会*2',
    'taskTip1': '保存功法即可完成领取任务',
    'taskTip2': '需要对方登录活动页并领取神功才算完成，可重复达成',
    'popupGetBookTitle': '获得功法',
    'bookGrade1': 'S级（传奇）功法',
    'bookGrade2': 'A级（史诗）功法',
    'bookGrade3': 'B级（稀有）功法',
    'popupBindTitle': '选择角色',
    'pServer': '请选择伺服器',
    'pRole': '请选择角色',
    'bindPopupBtn1': '确认',
    'bindPopupBtn2': '取消',
    'pLogin': '请先登录',
    'noRole': '没有游戏角色？',
    'popupInviteTitle': '邀请指挥官',
    'popupInviteTip': '您尚未加入小队，若邀请成功会自动创建小队',
    'popupFullTitle': '小队已满员',
    'popupFullTip': '前往社群寻找更多功夫小队',
    'popupQuitTitle': '退出小队',
    'popupQuitTip1': '退出当前小队后，您可以重新加入其他小队',
    'popupQuitTip2': '*已领取的奖励无法重复获得，每个帐号只能领取一次',
    'noBook': '点击抽取功法，马上领取神功',
    'getPopupBtn2': '分享到Facebook',
    'getPopupBtn3': '分享到Discord',
    'getPopupBtn4': '分享到Twitter',
    'getPopupBtn5': '分享到Naver',
    'serviceText': '服务条款',
    'privicyText': '隐私政策',
    'popupTip1': '请先选择角色',
    'fbText': '和我一起領取神功，加入我的功夫小隊吧（暗號：\${cipher}）',

    'errTip1': '操作失败，请联系客服或稍后再试',
    'errTip2': '频繁操作，请稍后再试',
    'errTip3': '发奖成功',
    'errTip4': '发奖失败，请联系客服或稍后再试',
    'errTip5': '参数错误，请稍后再试',
    'errTip6': '剩余抽取次数不足',
    'errTip7': '请输入正确的暗号',
    'errTip8': '暗号已失效，前往社群寻找其他小队',
    'errTip9': '小队已满，前往社群寻找其他小队',
    'errTip10': '未达成领取条件',
    'errTip11': '已领取过该奖励',
    'errTip12': '活动已结束',

    'ruleMainTitle': '「巅峰之邀」网页活动现已正式开启！',
    'ruleSubTitle': '参与活动领取你的专属神功，更有机会赢取丰厚奖励！',
    'ruleText1': '活动时间：',
    'ruleText2': '2023年9月4日00：00至2023年9月30日23：59 （UTC）',
    'ruleText3': '参与规则：',
    'ruleText4': '1.活动期间，指挥官可通过访问活动页面，领取专属的神功功法；',
    'ruleText5': '2.专属神功由玩家自行抽取的形式获得，玩家进入活动页面即可免费获得10次抽取功法的机会，所有功法残页共分为传奇(金)、史诗（紫）和稀有（蓝）三个品级；',
    'ruleText6': '3.玩家领取的功法残页，会随机生成唯一的部、章、页信息，且不与其他玩家重复，部、章、页等信息不随玩家选择的功法变化而更改；',
    'ruleText7': '4.玩家完成页面内的任务可领取功法抽取机会及其他丰富奖励，玩家通过完成任务可获取最多40次功法抽取机会，最多30次道具抽取机会；',
    'ruleText8': '5.玩家凭领取的专属功法残页图片可以参与社区与游戏内的奖励抽取活动，奖励抽取均由领取功法的部、章、页等组合信息决定；',
    'ruleText9': '6.将专属的功法残页分享至社区对应活动贴文或者活动区的留言区即可参与社区抽奖，游戏内的奖励抽取将在所有成功领取专属功法的玩家中抽取。',
    'ruleText10': '*参与该活动的社区地址请见规则最下方',
    'ruleText11': '注意事项：',
    'ruleText12': '1.社区和游戏内的奖励抽取结果将分别与9月30日（UTC）前在进行该活动的官方社交媒体及游戏内公示；',
    'ruleText13': '2.中奖的指挥官请在奖励公示后的15日内联系官方并填写中奖信息，未及时填写中奖信息的指挥官将被视为放弃奖励；',
    'ruleText14': '3.每位玩家仅能通过一个账号参与活动并领取奖励；',
    'ruleText15': '4.抽取功法后若您尚未登录账号，则功法抽取记录将被重置，建议您先登录账号再进行功法抽取；',
    'ruleText16': '5.达成任务条件后请及时领取奖励，玩家退出小队后会导致任务进度重置；',
    'ruleText17': '6.参与活动账号与领取奖励账号需保持一致。',
    'ruleText18': '活动奖励：',
    'ruleText19': '1.游戏内奖励抽取：“一代宗师”版本系列道具，包含主题永久避难所皮肤*1、主题铭牌*1、主题头像框*1、主题信纸*1，全游戏共1人；',
    'ruleText20': '2.社区奖励抽取：等额10美元礼品卡，全球社区共30人；',
    'ruleText21': '3.社区分享奖励：100钻，指挥官完成首次功法领取并分享后即可领取，不限人数。',
    'ruleText22': '概率公示：',
    'ruleText23': '1.功法抽取概率：',
    'ruleText24': '（S级传奇功法）太极拳：3.40%',
    'ruleText25': '（S级传奇功法）达摩剑：3.30%',
    'ruleText26': '（S级传奇功法）易筋经：3.30%',
    'ruleText27': '（A级史诗功法）纯阳剑：7.50%',
    'ruleText28': '（A级史诗功法）金钟罩：7.50%',
    'ruleText29': '（A级史诗功法）斩魔剑：7.50%',
    'ruleText30': '（A级史诗功法）分筋错骨手：7.50%',
    'ruleText31': '（B级稀有功法）螳螂爪：12%',
    'ruleText32': '（B级稀有功法）鹰爪功：12%',
    'ruleText33': '（B级稀有功法）八卦刀：12%',
    'ruleText34': '（B级稀有功法）风火棍：12%',
    'ruleText35': '（B级稀有功法）大雁功：12%',
    'ruleText36': '2.网页道具抽取概率：',
    'ruleText37': '皮肤碎片*10：0.60%',
    'ruleText38': '强化选择补给箱*5：1.66%',
    'ruleText39': '升星选择补给箱*5：1.66%',
    'ruleText40': '精密升星选择补给箱*3：1.66%',
    'ruleText41': '钻石*100：10%',
    'ruleText42': '血清1000：14.07%',
    'ruleText43': '加速10分钟*3：14.07%',
    'ruleText44': '食物10K：14.07%',
    'ruleText45': '木材10K：14.07%',
    'ruleText46': '钢材2K：14.07%',
    'ruleText47': '汽油500：14.07%',
    'ruleText48': '社区地址：',
    'ruleText49': 'Facebook：https://www.facebook.com/PnS.37Games/',
    'ruleText50': 'Discord：https://discord.com/invite/puzzlesandsurvival',
    'ruleText51': '本活动的最终解释权归游戏官方运营团队所有。',
  },
  'zh-tw': {
    'title': '領取神功，鑄煉超凡',
    'keyWords': '領取神功，鑄煉超凡',
    'description': '領取神功，鑄煉超凡',
    'website': '進入官網',
    'download': '下載遊戲',
    'menuTab1': '領取神功',
    'menuTab2': '小隊集結',
    'menuTab3': '道具抽取',
    'activityRule': '活動規則',
    'slogan': '領取神功，鑄煉超凡',
    'time': '活動時間：2023.09.04 0:00 ～ 2023.09.30 23:59（UTC）',
    'login': '【登錄】',
    'logout': '【切換帳號】',
    'bind': '【綁定角色】',
    'bookName1': '太極拳',
    'bookName2': '達摩劍',
    'bookName3': '易筋經',
    'bookName4': '純陽劍',
    'bookName5': '金鐘罩',
    'bookName6': '斬魔劍',
    'bookName7': '分筋錯骨手',
    'bookName8': '螳螂爪',
    'bookName9': '鷹爪功',
    'bookName10': '八卦刀',
    'bookName11': '風火棍',
    'bookName12': '大雁功',
    'bookIntroduction1': '「陰陽相生，變化無窮」',
    'bookIntroduction2': '「心無雜念，禪入劍式」',
    'bookIntroduction3': '「改變筋骨，打通經絡」',
    'bookIntroduction4': '「以八卦自然之象，出五行變化之數」',
    'bookIntroduction5': '「拒堅抗銳，如罩金鐘」',
    'bookIntroduction6': '「掌可代刃，砍石分鐵」',
    'bookIntroduction7': '「化打合一，控敵關節」',
    'bookIntroduction8': '「螳螂斫物，柔中帶剛」',
    'bookIntroduction9': '「指如鷹爪，洞胸入腑」',
    'bookIntroduction10': '「刀如游龍，滔滔不絕」',
    'bookIntroduction11': '「吞吐沉浮，刺心戮喉」',
    'bookIntroduction12': '「緩急相應，強弱相兼」',
    'bookTag1': '武當',
    'bookTag2': '少林',
    'bookTag3': '昆侖',
    'bookPageInfo': '\${page1} 部<br>\${page2} 章<br>\${page3} 節',
    'weaponName1': '拐',
    'weaponName2': '鐧',
    'weaponName3': '斧',
    'weaponName4': '戟',
    'weaponName5': '刀',
    'weaponName6': '木人樁',
    'weaponName7': '雙截棍',
    'weaponName8': '槍',
    'weaponName9': '錘',
    'weaponName10': '鉞',
    'weaponName11': '飛刀',
    'weaponName12': '弓',
    'weaponName13': '鉤',
    'weaponName14': '狼牙棒',
    'weaponName15': '蛇矛',
    'weaponName16': '八斬刀',
    'surplusBookChance': '剩餘抽取次數: ',
    'lotteryBook': '抽取功法',
    'getMore': '獲取更多',
    'getMoreTip': '參與集結活動，可抽取更多功法',
    'partTitle1': '定制功法書頁',
    'partTitle2': '小隊集結',
    'partTitle3': '道具抽取',
    'partTitle4': '下載「末日喧囂」體驗更多玩法',
    'saveShareText': '保存並分享',
    'tabText1': '功法',
    'tabText2': '書頁',
    'tabText3': '英雄',
    'tabText4': '武器',
    'myTeam': '我的小隊：',
    'teamState1': '尚未加入',
    'teamState2': '已加入 \${teamNum} 人',
    'teamState3': '集結成功！',
    'createTeam': '創建小隊',
    'addTeam': '加入小隊',
    'cipherInputTip': '輸入集結暗號即可加入小隊',
    'cipherLabel': '集結暗號：',
    'linkLabel': '集結連結：',
    'goInvite': '去邀請',
    'copyText': '複製',
    'concludeTip': '您仍可以繼續邀請更多指揮官',
    'concludeLabel': '集結成功獎勵',
    'getState1': '未達成',
    'getState2': '領取',
    'getState3': '已領取',
    'getState4': '可重複達成',
    'seeAward': '查看獎勵',
    'awardBag': '獎勵背包',
    'lotteryText': '抽獎',
    'surplusSkinChance': '當前剩餘抽獎次數：',
    'awardName1': '造型碎片*10',
    'awardName2': '強化選擇補給箱*5',
    'awardName3': '升星選擇補給箱*5',
    'awardName4': '精密升星選擇補給箱*3',
    'awardName5': '鑽石*100',
    'awardName6': '血清1000',
    'awardName7': '加速10分鐘*3',
    'awardName8': '食物10K',
    'awardName9': '木材10K',
    'awardName10': '鋼材2K',
    'awardName11': '汽油500',
    'popupShareTitle': '分享神功',
    'popupShareTip': '您尚未加入小隊，分享後可能無法獲得獎勵',
    'popupShareTipBtn1': '【創建小隊】',
    'popupShareTipBtn2': '【去加入】',
    'saveImg': '保存圖片',
    'copyShare': '複製去分享',
    'copyShareTip': '已為您複製邀請資訊，去社群邀請更多指揮官加入小隊以獲得更多獎勵吧',
    'copyShareText': '和我一起領取神功，加入我的功夫小隊吧（暗號：\${cipher}）；點擊領取神功：',
    'taskText1': '領取神功：',
    'taskText2': '分享神功：',
    'taskText3': '每成功邀請1位指揮官：',
    'taskText4': '小隊人數達到2人：',
    'taskText5': '小隊人數達到3人：',
    'taskText6': '小隊人數達到4人：',
    'taskAward1': '抽取機會*2',
    'taskAward2': '100鑽石',
    'taskAward3': '抽取機會*2',
    'taskTip1': '保存神功即可完成領取任務',
    'taskTip2': '需要對方登錄活動頁並領取神功才算完成，可重複達成',
    'popupGetBookTitle': '獲得功法',
    'bookGrade1': 'S級（傳奇）功法',
    'bookGrade2': 'A級（史詩）功法',
    'bookGrade3': 'B級（稀有）功法',
    'popupBindTitle': '選擇角色',
    'pServer': '請選擇伺服器',
    'pRole': '請選擇角色',
    'bindPopupBtn1': '確認',
    'bindPopupBtn2': '取消',
    'pLogin': '請先登錄',
    'noRole': '沒有遊戲角色？',
    'popupInviteTitle': '邀請指揮官',
    'popupInviteTip': '',
    'popupFullTitle': '小隊已滿員',
    'popupFullTip': '前往社群尋找更多功夫小隊',
    'popupQuitTitle': '退出小隊',
    'popupQuitTip1': '退出當前小隊後，您可以重新加入其他小隊',
    'popupQuitTip2': '*已領取的獎勵無法重複獲得，每個帳號只能領取一次',
    'noBook': '點擊抽取功法，馬上領取神功',
    'getPopupBtn2': '分享到Facebook',
    'getPopupBtn3': '分享到Discord',
    'getPopupBtn4': '分享到Twitter',
    'getPopupBtn5': '分享到Naver',
    'serviceText': '服務條款',
    'privicyText': '隱私政策',
    'popupTip1': '請先選擇角色',
    'fbText': '和我一起領取神功，加入我的功夫小隊吧（暗號：\${cipher}）',

    'errTip1': '操作失敗，請聯繫客服或稍後再試',
    'errTip2': '頻繁操作，請稍後再試',
    'errTip3': '發獎成功',
    'errTip4': '發獎失敗，請聯繫客服或稍後再試',
    'errTip5': '參數錯誤，請稍後再試',
    'errTip6': '剩餘抽取次數不足',
    'errTip7': '請輸入正確的暗號',
    'errTip8': '暗號已失效，前往社群尋找其他小隊',
    'errTip9': '小隊已滿，前往社群尋找其他小隊',
    'errTip10': '未達成領取條件',
    'errTip11': '已領取過該獎勵',
    'errTip12': '活動已結束',

    'ruleMainTitle': '「巔峰之邀」網頁活動現已正式開啟！',
    'ruleSubTitle': '參與活動領取你的專屬神功，更有機會贏取豐厚獎勵！',
    'ruleText1': '活動時間：',
    'ruleText2': '2023年9月4日00：00至2023年9月30日23：59 （UTC）',
    'ruleText3': '參與規則：',
    'ruleText4': '1.活動期間，指揮官可通過訪問活動頁面，領取專屬的神功功法；',
    'ruleText5': '2.專屬神功由玩家自行抽取的形式獲得，玩家進入活動頁面即可免費獲得10次抽取功法的機會，所有功法殘頁共分為傳奇(金)、史詩（紫）和稀有（藍）三個品級；',
    'ruleText6': '3.玩家領取的功法殘頁，會隨機生成唯一的部、章、節資訊，且不與其他玩家重複，部、章、節等資訊不隨玩家選擇的功法變化而更改；',
    'ruleText7': '4.玩家完成頁面內的任務可領取功法抽取機會及其他豐富獎勵，玩家通過完成任務可獲取最多40次功法抽取機會，最多30次道具抽取機會；',
    'ruleText8': '5.玩家憑領取的專屬功法殘頁圖片可以參與社區與遊戲內的獎勵抽取活動，獎勵抽取均由領取功法的部、章、節等組合資訊決定；',
    'ruleText9': '6.將專屬的功法殘頁分享至社區對應活動貼文或者活動區的留言區即可參與社區抽獎，遊戲內的獎勵抽取將在所有成功領取專屬功法的玩家中抽取。',
    'ruleText10': '*參與該活動的社區位址請見規則最下方',
    'ruleText11': '注意事項：',
    'ruleText12': '1.社區和遊戲內的獎勵抽取結果將分別與9月30日（UTC）前在進行該活動的官方社交媒體及遊戲內公示；',
    'ruleText13': '2.中獎的指揮官請在獎勵公示後的15日內聯繫官方並填寫中獎資訊，未及時填寫中獎資訊的指揮官將被視為放棄獎勵；',
    'ruleText14': '3.每位玩家僅能通過一個帳號參與活動並領取獎勵；',
    'ruleText15': '4.抽取功法後若您尚未登錄帳號，則功法抽取記錄將被重置，建議您先登錄帳號再進行功法抽取；',
    'ruleText16': '5.達成任務條件後請及時領取獎勵，玩家退出小隊後會導致任務進度重置；',
    'ruleText17': '6.參與活動帳號與領取獎勵帳號需保持一致。',
    'ruleText18': '活動獎勵：',
    'ruleText19': '1.“一代宗師”版本系列道具，包含主題永久避難所皮膚*1、主題銘牌*1、主題頭像框*1、主題信紙*1，全遊戲共1人；',
    'ruleText20': '2.社區獎勵抽取：等額10美元禮品卡，全球社區共30人；',
    'ruleText21': '3.社區分享獎勵：100鑽，指揮官完成首次功法領取並分享後即可領取，不限人數。',
    'ruleText22': '機率公告：',
    'ruleText23': '1.功法抽取機率：',
    'ruleText24': '（S級傳奇功法）太極拳：3.40%',
    'ruleText25': '（S級傳奇功法）達摩劍：3.30%',
    'ruleText26': '（S級傳奇功法）易筋經：3.30%',
    'ruleText27': '（A級史詩功法）純陽劍：7.50%',
    'ruleText28': '（A級史詩功法）金鐘罩：7.50%',
    'ruleText29': '（A級史詩功法）斬魔劍：7.50%',
    'ruleText30': '（A級史詩功法）分筋錯骨手：7.50%',
    'ruleText31': '（B級稀有功法）螳螂爪：12%',
    'ruleText32': '（B級稀有功法）鷹爪功：12%',
    'ruleText33': '（B級稀有功法）八卦刀：12%',
    'ruleText34': '（B級稀有功法）風火棍：12%',
    'ruleText35': '（B級稀有功法）大雁功：12%',
    'ruleText36': '2.網頁道具抽取機率：',
    'ruleText37': '造型碎片*10：0.60%',
    'ruleText38': '強化選擇補給箱*5：1.66%',
    'ruleText39': '升星選擇補給箱*5：1.66%',
    'ruleText40': '精密升星選擇補給箱*3：1.66%',
    'ruleText41': '鑽石*100：10%',
    'ruleText42': '血清1000：14.07%',
    'ruleText43': '加速10分鐘*3：14.07%',
    'ruleText44': '食物10K：14.07%',
    'ruleText45': '木材10K：14.07%',
    'ruleText46': '鋼材2K：14.07%',
    'ruleText47': '汽油500：14.07%',
    'ruleText48': '社區地址：',
    'ruleText49': 'Facebook：https://www.facebook.com/PnS.TW',
    'ruleText50': 'Discord：https://discord.com/invite/puzzlesandsurvival',
    'ruleText51': '本活動的最終解釋權歸遊戲官方運營團隊所有。',
  },
  'en-us': {
    'title': 'Acquire Techniques and Forge a Legend',
    'keyWords': 'Acquire Techniques and Forge a Legend',
    'description': 'Acquire Techniques and Forge a Legend',
    'website': 'Official Website',
    'download': 'Download Game',
    'menuTab1': 'Acquire Technique',
    'menuTab2': 'Squad',
    'menuTab3': 'Draw Items',
    'activityRule': 'Event Rules',
    'slogan': 'Acquire Techniques and Forge a Legend',
    'time': 'Event Time: 2023/09/04 00:00 - 2023/09/30 23:59 (UTC)',
    'login': '[Log In]',
    'logout': '[Switch Account]',
    'bind': '[Bind Character]',
    'bookName1': 'Tai Chi',
    'bookName2': 'Damo Sword',
    'bookName3': 'Yijin Jing',
    'bookName4': 'Yang Blade',
    'bookName5': 'Golden Bell Shield',
    'bookName6': 'Demonslayer',
    'bookName7': 'Joint Lock',
    'bookName8': 'Mantis Claw',
    'bookName9': 'Eagle Claw',
    'bookName10': 'Bagua Dao',
    'bookName11': 'Wind and Fire Stick',
    'bookName12': 'Wild Goose',
    'bookIntroduction1': 'Endless Changes Through Yin-Yang Interplay',
    'bookIntroduction2': 'Embodying Zen in Sword Techniques',
    'bookIntroduction3': 'Alter Muscles and Bones, Unblock Meridians',
    'bookIntroduction4': "Five Elements' Flux: Eight Trigrams' Art",
    'bookIntroduction5': 'Iron Shield, Impenetrable Defense',
    'bookIntroduction6': 'Palm as Blade, Splitting Stone and Iron',
    'bookIntroduction7': 'Joint Control: Fusion of Striking and Grappling',
    'bookIntroduction8': 'Mantis Strikes, Combining Softness and Strength',
    'bookIntroduction9': 'Fingers Like Eagle Claws, Penetrating Chest',
    'bookIntroduction10': 'Sword Moves Like a Roaming Dragon',
    'bookIntroduction11': 'Inhale, Exhale, and Penetrate',
    'bookIntroduction12': 'Balance of Speed and Strength',
    'bookTag1': 'Wudang',
    'bookTag2': 'Shaolin',
    'bookTag3': 'Kunlun',
    'bookPageInfo': 'Volume \${page1}<br>Chapter \${page2}<br>Page \${page3}',
    'weaponName1': 'Tonfa',
    'weaponName2': 'Jian',
    'weaponName3': 'Axe',
    'weaponName4': 'Halberd',
    'weaponName5': 'Sword',
    'weaponName6': 'Wooden Dummy',
    'weaponName7': 'Nunchucks',
    'weaponName8': 'Spear',
    'weaponName9': 'Hammer',
    'weaponName10': 'Ono',
    'weaponName11': 'Throwing Knife',
    'weaponName12': 'Bow',
    'weaponName13': 'Hook',
    'weaponName14': "Wolf's Tooth Club",
    'weaponName15': 'Snake Spear',
    'weaponName16': 'Baat Cham Dao',
    'surplusBookChance': 'Remaining Draws: ',
    'lotteryBook': 'Draw Technique',
    'getMore': 'Get More',
    'getMoreTip': 'Create or join a squad to earn more drawing chances',
    'partTitle1': 'Customize Technique Book',
    'partTitle2': 'Squad',
    'partTitle3': 'Draw Items',
    'partTitle4': 'Download Puzzles & Survival for an immersive adventure',
    'saveShareText': 'Save & Share',
    'tabText1': 'Technique',
    'tabText2': 'Page',
    'tabText3': 'Hero',
    'tabText4': 'Weapon',
    'myTeam': 'My Squad: ',
    'teamState1': 'No members yet',
    'teamState2': '\${teamNum} Member Joined',
    'teamState3': 'Assembly Successful!',
    'createTeam': 'Create Squad',
    'addTeam': 'Join Squad',
    'cipherInputTip': 'Enter the code to join the squad',
    'cipherLabel': 'Code:',
    'linkLabel': 'Link:',
    'goInvite': 'Invite',
    'copyText': 'Copy',
    'concludeTip': 'You can continue to invite more Commanders',
    'concludeLabel': 'Assembly Rewards',
    'getState1': 'Not Achieved',
    'getState2': 'Claim',
    'getState3': 'Claimed',
    'getState4': 'Can be achieved repeatedly',
    'seeAward': 'View Rewards',
    'awardBag': 'Reward Bag',
    'lotteryText': 'Draw',
    'surplusSkinChance': 'Remaining Draws: ',
    'awardName1': 'Skin Frag x10',
    'awardName2': 'Enhance Choice Box x5',
    'awardName3': 'Promote Choice Box x5',
    'awardName4': 'Promote Choice Box II x3',
    'awardName5': '100 Diamonds',
    'awardName6': '1K Antiserum',
    'awardName7': '10-min Speedup x3',
    'awardName8': '10K Food',
    'awardName9': '10K Wood',
    'awardName10': '2K Steel',
    'awardName11': '500 Gas',
    'popupShareTitle': 'Share Technique',
    'popupShareTip': "You haven't joined a squad yet. Sharing might not yield rewards.",
    'popupShareTipBtn1': '[Create Squad]',
    'popupShareTipBtn2': '[Join Now]',
    'saveImg': 'Save',
    'copyShare': 'Copy & Share',
    'copyShareTip': 'Invitation information copied. Invite more Commanders to join your squad for more rewards.',
    'copyShareText': 'Join my kung fu squad to acquire techniques together! (Code: \${cipher}); Tap to claim techniques:',
    'taskText1': 'Claim Exclusive Technique:',
    'taskText2': 'Share Technique:',
    'taskText3': 'Invite 1 Commander Successfully:',
    'taskText4': 'Squad Size Reaches 2:',
    'taskText5': 'Squad Size Reaches 3:',
    'taskText6': 'Squad Size Reaches 4:',
    'taskAward1': 'Drawing Chance x2',
    'taskAward2': '100 Diamonds',
    'taskAward3': 'Drawing Chance x2',
    'taskTip1': 'Save to acquire the technique',
    'taskTip2': 'The invited Commander needs to log in to the event page and claim techniques to complete the invitation; can be achieved repeatedly.',
    'popupGetBookTitle': 'New Technique',
    'bookGrade1': 'S-Grade (Legendary) Technique',
    'bookGrade2': 'A-Grade (Epic) Technique',
    'bookGrade3': 'B-Grade (Rare) Technique',
    'popupBindTitle': 'Select Character',
    'pServer': 'Select server',
    'pRole': 'Select character',
    'bindPopupBtn1': 'Confirm',
    'bindPopupBtn2': 'Cancel',
    'pLogin': 'Please log in first',
    'noRole': "Don't have a character?",
    'popupInviteTitle': 'Invite Commander',
    'popupInviteTip': '',
    'popupFullTitle': 'Squad Full',
    'popupFullTip': 'Visit the official community to find more kung fu squads',
    'popupQuitTitle': 'Leave Squad',
    'popupQuitTip1': 'After leaving the current squad, you can join another squad.',
    'popupQuitTip2': '*Rewards that have been claimed cannot be reclaimed; each account can only claim once.',
    'noBook': 'Tap to draw and receive your exclusive technique',
    'getPopupBtn2': 'Share on Facebook',
    'getPopupBtn3': 'Share on Discord',
    'getPopupBtn4': 'Share on Twitter',
    'getPopupBtn5': 'Share on Naver',
    'serviceText': 'TERMS OF SERVICE',
    'privicyText': 'PRIVACY POLICY',
    'popupTip1': 'Select character',
    'fbText': 'Join my kung fu squad to acquire techniques together! (Code: \${cipher})',

    'errTip1': 'Operation failed. Please contact Customer Support or try again later.',
    'errTip2': 'Operation too frequent. Please try again later.',
    'errTip3': 'Reward sent',
    'errTip4': 'Reward distribution failed. Please contact Customer Support or try again later.',
    'errTip5': 'Parameter error. Please try again later.',
    'errTip6': 'Insufficient drawing chances',
    'errTip7': 'Please enter the correct code',
    'errTip8': 'Code has expired. Please find other squads in the community.',
    'errTip9': 'Squad is full. Please join other squads.',
    'errTip10': 'Requirements not met',
    'errTip11': 'Reward has already been claimed.',
    'errTip12': 'The event has ended.',

    'ruleMainTitle': 'The Apex Challenge event is now officially open!',
    'ruleSubTitle': 'Participate to claim your exclusive technique, with a chance to win rich rewards!',
    'ruleText1': 'Event Time:',
    'ruleText2': 'September 4, 2023, 00:00 to September 30, 2023, 23:59 (UTC)',
    'ruleText3': 'Participation Rules:',
    'ruleText4': '1. During the event, Commanders can visit the event page to draw their exclusive techniques.',
    'ruleText5': '2. Commanders can get 10 free chances to draw techniques upon accessing the event page. All technique fragments are divided into three grades: Legendary (Gold), Epic (Purple), and Rare (Blue).',
    'ruleText6': "3. The technique fragments obtained by players will generate unique volume, chapter, and page information randomly. This information will not change based on the player's choice of technique.",
    'ruleText7': '4. By completing quests displayed on the page, players can claim drawing chances and other rewards. Players can earn up to 40 technique drawing chances and up to 30 item drawing chances by completing quests.',
    'ruleText8': '5. Players can participate in community and in-game draws. The information of volume, chapter, and page obtained by claiming techniques will determine the reward draw.',
    'ruleText9': "6. The unique technique fragment image can be shared to the community's corresponding event post or the comments section to participate in the community draw. The in-game reward winners will be selected from all players who have successfully claimed exclusive techniques.",
    'ruleText10': '*For the community link, please refer to the bottom of the rules section.',
    'ruleText11': 'Notes:',
    'ruleText12': '1. The results for the in-game and community draws will be announced on the official social media and in-game before September 30 (UTC).',
    'ruleText13': '2. Winning Commanders need to contact the official within 15 days after the reward announcement and provide the required information. Commanders who fail to provide the required information in time will be considered as giving up the reward.',
    'ruleText14': '3. Each player can only participate in the event and claim rewards with one account.',
    'ruleText15': "4. If you haven't logged in to your account after drawing techniques, your drawing history will be reset. We recommend logging in before drawing techniques.",
    'ruleText16': '5. Leaving your squad will reset quest progress. Please claim rewards promptly after completing the quests.',
    'ruleText17': '6. The account used to participate in the event must match the account used to claim rewards.',
    'ruleText18': 'Event Rewards:',
    'ruleText19': '1. In-Game Draw: Kung-Fu-Master-themed items, including Permanent Sanctuary Skin x1, Themed Nameplate x1, Themed Frame x1, Themed Mail Background x1. Winner x1.',
    'ruleText20': '2. Community Draw: $10 Gift Card, a total of 30 winners across all communities.',
    'ruleText21': '3. Community Sharing Reward: 100 Diamonds. Commanders can claim after successfully acquiring and sharing their first technique. No limit on the number of recipients.',
    'ruleText22': 'Probabilities',
    'ruleText23': '1. Techniques:',
    'ruleText24': '(S-Grade Legendary Techniques) Tai Chi: 3.40%',
    'ruleText25': '(S-Grade Legendary Techniques) Damo Sword: 3.30%',
    'ruleText26': '(S-Grade Legendary Techniques) Yijin Jing: 3.30%',
    'ruleText27': '(A-Grade Epic Techniques) Yang Blade: 7.50%',
    'ruleText28': '(A-Grade Epic Techniques) Golden Bell Shield: 7.50%',
    'ruleText29': '(A-Grade Epic Techniques) Demonslayer: 7.50%',
    'ruleText30': '(A-Grade Epic Techniques) Joint Lock: 7.50%',
    'ruleText31': '(B-Grade Rare Techniques) Mantis Claw: 12%',
    'ruleText32': '(B-Grade Rare Techniques) Eagle Claw: 12%',
    'ruleText33': '(B-Grade Rare Techniques) Bagua Dao: 12%',
    'ruleText34': '(B-Grade Rare Techniques) Wind and Fire Stick: 12%',
    'ruleText35': '(B-Grade Rare Techniques) Wild Goose: 12%',
    'ruleText36': '2. Other Items:',
    'ruleText37': 'Skin Frag x10: 0.60%',
    'ruleText38': 'Enhance Choice Box x5: 1.66%',
    'ruleText39': 'Promote Choice Box x5: 1.66%',
    'ruleText40': 'Promote Choice Box II x3: 1.66%',
    'ruleText41': '100 Diamonds: 10%',
    'ruleText42': '1K Antiserum: 14.07%',
    'ruleText43': '10-min Speedup x3: 14.07%',
    'ruleText44': '10K Food: 14.07%',
    'ruleText45': '10K Wood: 14.07%',
    'ruleText46': '2K Steel: 14.07%',
    'ruleText47': '500 Gas: 14.07%',
    'ruleText48': 'Community:',
    'ruleText49': 'Facebook：https://www.facebook.com/PnS.37Games/',
    'ruleText50': 'Discord：https://discord.com/invite/puzzlesandsurvival',
    'ruleText51': 'Puzzles & Survival operations team reserves the right to interpret the rules of this event.',
  },
  'ja-jp': {
    'title': '絶世武功を手に入れ、頂上へ',
    'keyWords': '絶世武功を手に入れ、頂上へ',
    'description': '絶世武功を手に入れ、頂上へ',
    'website': '公式サイトへ',
    'download': 'ダウンロード',
    'menuTab1': '武功受領',
    'menuTab2': '友達招待',
    'menuTab3': '抽選',
    'activityRule': 'ルール',
    'slogan': '絶世武功を手に入れ、頂上へ',
    'time': '開催時間：2023.09.04 0:00 ～ 2023.09.30 23:59（UTC）',
    'login': 'ログイン',
    'logout': '切り替え',
    'bind': 'キャラ連携',
    'bookName1': '太極拳',
    'bookName2': '達磨剣',
    'bookName3': '易筋経',
    'bookName4': '純陽剣',
    'bookName5': '金鐘罩',
    'bookName6': '破魔剣',
    'bookName7': '分筋錯骨手',
    'bookName8': '蟷螂拳',
    'bookName9': '鷹拳',
    'bookName10': '八卦刀',
    'bookName11': '風火棒',
    'bookName12': '大雁気功',
    'bookIntroduction1': '「陰陽から、万物生ずる」',
    'bookIntroduction2': '「無念無我、剣心一体」',
    'bookIntroduction3': '「筋骨を変え、経脈巡らす」',
    'bookIntroduction4': '「八卦で万象を占い、五行で事象を測る」',
    'bookIntroduction5': '「身を守ること、金鐘の如く」',
    'bookIntroduction6': '「手を刃と化し、岩石を両断」',
    'bookIntroduction7': '「防御は最大の攻撃、関節を制御」',
    'bookIntroduction8': '「蟷螂を模し、柔中剛あり」',
    'bookIntroduction9': '「鷹の爪の如く、臓器を穿つ」',
    'bookIntroduction10': '「打てば遊龍、変われば乾坤」',
    'bookIntroduction11': '「進退自在、正中線への刺突」',
    'bookIntroduction12': '「時には素早く、時には緩やかに」',
    'bookTag1': '武当',
    'bookTag2': '少林',
    'bookTag3': '崑崙',
    'bookPageInfo': '\${page1} 部<br>\${page2} 章<br>\${page3} 節',
    'weaponName1': 'トンファー',
    'weaponName2': '鐧',
    'weaponName3': '斧',
    'weaponName4': '戟',
    'weaponName5': '刀',
    'weaponName6': '木人杭',
    'weaponName7': 'ヌンチャク',
    'weaponName8': '槍',
    'weaponName9': '槌',
    'weaponName10': '鉞',
    'weaponName11': '飛刀',
    'weaponName12': '弓',
    'weaponName13': '鈎',
    'weaponName14': '狼牙棒',
    'weaponName15': '蛇矛',
    'weaponName16': '八斬刀',
    'surplusBookChance': '残り抽選回数: ',
    'lotteryBook': '武功抽選',
    'getMore': 'もっと獲得',
    'getMoreTip': '友達を招待し、続々と武功を抽選しよう',
    'partTitle1': '功法選択',
    'partTitle2': '友達招待',
    'partTitle3': '抽選',
    'partTitle4': '『パズル&サバイバル』をダウンロードしてみよう',
    'saveShareText': '保存&シェア',
    'tabText1': '武功',
    'tabText2': 'ページ',
    'tabText3': '英雄',
    'tabText4': '武器',
    'myTeam': 'マイチーム：',
    'teamState1': '未加入',
    'teamState2': 'チームメンバーが \${teamNum} 人います。',
    'teamState3': '招待成功',
    'createTeam': 'チーム作成',
    'addTeam': '加入',
    'cipherInputTip': '暗号を入力すると加入できます',
    'cipherLabel': '暗号：',
    'linkLabel': '招待リンク：',
    'goInvite': '招待',
    'copyText': 'コピー',
    'concludeTip': '引き続き友達を招待することができます',
    'concludeLabel': '招待報酬',
    'getState1': '未達成',
    'getState2': '受け取る',
    'getState3': '受け取り済み',
    'getState4': '重複達成可能',
    'seeAward': '報酬確認',
    'awardBag': '報酬バッグ',
    'lotteryText': '抽選',
    'surplusSkinChance': '残り抽選回数：',
    'awardName1': 'スキン破片×10',
    'awardName2': '選択型強化補給×5',
    'awardName3': '選択型プロモート補給×5',
    'awardName4': '選択型プロモート補給（エリート）×3',
    'awardName5': '100ダイヤ',
    'awardName6': '血清×1000',
    'awardName7': 'ブースト（10分間）×3',
    'awardName8': '食料×10000',
    'awardName9': '木材×10000',
    'awardName10': '鋼材×2000',
    'awardName11': 'ガス×500',
    'popupShareTitle': '絶世武功をシェア',
    'popupShareTip': 'チームに加入していないため、シェアしても報酬を獲得できません。',
    'popupShareTipBtn1': 'チーム作成 ',
    'popupShareTipBtn2': '加入へ',
    'saveImg': '画像保存',
    'copyShare': 'コピー&シェア',
    'copyShareTip': '招待内容をコピーしました。コミュニティにでより多くの友達を招待して、報酬を手に入れましょう',
    'copyShareText': '絶世武功を手に入れ、私のカンフーチームに参加してみましょう（暗号：\${cipher}）タップで受領：',
    'taskText1': '専用武功の受領：',
    'taskText2': '武功シェア：',
    'taskText3': '友達を1人招待：',
    'taskText4': 'チーム人数が2人に到達：',
    'taskText5': 'チーム人数が3人に到達：',
    'taskText6': 'チーム人数が4人に到達：',
    'taskAward1': '抽選回数×2',
    'taskAward2': 'ダイヤ×100',
    'taskAward3': '抽選回数×2',
    'taskTip1': '武功を保存すると受領成功とみなされます。',
    'taskTip2': '招待された対象がイベント画面にログインして、絶世武功を手に入れると任務完了です。重複達成可能',
    'popupGetBookTitle': '武功獲得',
    'bookGrade1': 'SR武功',
    'bookGrade2': 'HR武功',
    'bookGrade3': 'R武功',
    'popupBindTitle': 'キャラクター選択',
    'pServer': 'サーバーを選択してください',
    'pRole': 'キャラクターを選択してください',
    'bindPopupBtn1': '確定',
    'bindPopupBtn2': 'キャンセル',
    'pLogin': 'ログインしてください',
    'noRole': 'キャラクターを持っていない方',
    'popupInviteTitle': '友達招待',
    'popupInviteTip': '',
    'popupFullTitle': 'チーム人数が上限に達しました',
    'popupFullTip': 'コミュニティに移動し、チームを拡大しましょう',
    'popupQuitTitle': '脱退',
    'popupQuitTip1': 'このチームから脱退後、他のチームに加入することができます',
    'popupQuitTip2': 'すでに受取った報酬は再受領することができません。1つのアカウントにつき1回のみ受領できます。',
    'noBook': 'タップで絶世武功を手に入れよう',
    'getPopupBtn2': 'Facebookにシェア',
    'getPopupBtn3': 'Discordにシェア',
    'getPopupBtn4': 'Twitterにシェア',
    'getPopupBtn5': 'Naverにシェア',
    'serviceText': '利用規約',
    'privicyText': 'プライバシーポリシー',
    'popupTip1': 'Select character',
    'fbText': '絶世武功を手に入れ、私のカンフーチームに参加してみましょう（暗号：\${cipher}）',

    'errTip1': '操作失敗。お問い合わせに連絡するか、しばらくしてからもう一度試してください。',
    'errTip2': '操作が頻繁すぎます。しばらくしてからもう一度試してください。',
    'errTip3': '配布成功',
    'errTip4': '配布失敗。お問い合わせに連絡するか、しばらくしてからもう一度試してください。',
    'errTip5': 'パラメータエラー。後でもう一度お試し下さい。',
    'errTip6': '抽選回数が足りません。',
    'errTip7': '正しい暗号を入力してください。',
    'errTip8': '暗号が無効になりました。コミュニティに移動し、新しいチームを探しましょう',
    'errTip9': 'チーム人数が上限に達しました。コミュニティに移動し、新しいチームを探しましょう',
    'errTip10': '受領条件を満たしていません。',
    'errTip11': 'すでにこの報酬を受け取りました。',
    'errTip12': 'イベントが終了しました。',

    'ruleMainTitle': '「頂上戦争」イベントただ今開催中！',
    'ruleSubTitle': 'イベントに参加すると専用の絶世武功や豪華報酬などが手に入る！',
    'ruleText1': '開催時間:',
    'ruleText2': '2023年9月4日00：00～2023年9月30日23：59 （UTC）',
    'ruleText3': 'ルール：',
    'ruleText4': '1.イベント期間中、イベント画面にログインすると専用武功を受け取れます。',
    'ruleText5': '2.抽選で専用武功を手に入れることができます。イベント画面にログインすると抽選回数を10回獲得できます。秘伝書の破片はSR、HR、Rの3種類があります。',
    'ruleText6': '3.秘伝書の破片を受け取ると、ランダムで唯一の部、章、節の情報が生成されます。プレイヤーが選択した武功は部、章、節の生成に影響しません。',
    'ruleText7': '4.画面上の任務を完了すると武功抽選回数や報酬などが手に入ります。任務を完了すると最大で40回の抽選回数と30回のアイテム抽選回数を獲得できます。',
    'ruleText8': '5.受け取った専用武功の秘伝書の破片を使用するとコミュニティやゲーム内報酬抽選イベントに参加することができます。生成した部、章、節の情報に応じて報酬を配布します。',
    'ruleText9': '6.専用武功の秘伝書の破片をコミュニティの指定イベントにシェアする、またはコメントするとコミュニティの抽選に参加できます。専用武功を受け取ったプレイヤーがゲーム内報酬抽選イベントに参加できます。',
    'ruleText10': '*コミュニティリンクはルールの一番下をご覧ください。',
    'ruleText11': '注意事項：',
    'ruleText12': '1.コミュニティとゲーム内の報酬抽選結果は9月30日（UTC）前に公式SNSおよびゲーム内で発表されます。',
    'ruleText13': '2.当選したプレイヤーは結果発表後15日以内に公式スタッフに連絡して、当選情報を提供してください。それを過ぎた場合、当選情報を提供していない方は報酬を放棄したものとみなされますので、ご了承ください。',
    'ruleText14': '3.イベントの参加と報酬の受領に使用できるのは1つのアカウントだけです。',
    'ruleText15': '4.武功を抽選する前にログインする必要があります。ログインしなかった場合、抽選で獲得した武功がリセットされます。',
    'ruleText16': '5.チームメンバーが脱退した場合、任務進捗がリセットされる可能性があります。条件達成後、早めに報酬をお受け取り下さい。',
    'ruleText17': '6.イベント参加と報酬受領には同じアカウントを使用する必要があります。',
    'ruleText18': '報酬について',
    'ruleText19': '1.ゲーム内報酬 カンフーマスターシリーズアイテム（対応テーマの永久避難所スキン×1、名札×1、名札×1、チャット背景×1） 当選人数：1名',
    'ruleText20': '2.コミュニティ報酬 10ドル相当のギフトカード 当選人数：30人',
    'ruleText21': '3.コミュニティ報酬 100ダイヤ 当選人数：制限なし 初めて受け取った武功をシェアすると受け取れます。',
    'ruleText22': '確率',
    'ruleText23': '1．武功抽選確率',
    'ruleText24': 'SR武功「太極拳」　　3.40%',
    'ruleText25': 'SR武功「達磨剣」　　3.30%',
    'ruleText26': 'SR武功「易筋経」　　3.30%',
    'ruleText27': 'HR武功「純陽剣」　　7.50%',
    'ruleText28': 'HR武功「金鐘罩」　7.50%',
    'ruleText29': 'HR武功「破魔剣」　　7.50%',
    'ruleText30': 'HR武功「分筋錯骨手」　　7.50%',
    'ruleText31': 'R武功「蟷螂拳」　　12%',
    'ruleText32': 'R武功「鷹拳」　　12%',
    'ruleText33': 'R武功「八卦刀」　　12%',
    'ruleText34': 'R武功「風火棒」　　12%',
    'ruleText35': 'R武功「大雁気功」　　12%',
    'ruleText36': '2.サイトのアイテム抽選確率',
    'ruleText37': 'スキン破片×10　　　　0.60%',
    'ruleText38': '選択型強化補給×5　　1.66%',
    'ruleText39': '選択型プロモート補給×5　　1.66%',
    'ruleText40': '選択型プロモート補給（エリート）×3　　1.66%',
    'ruleText41': '100ダイヤ　　10%',
    'ruleText42': '血清×1000　　14.07%',
    'ruleText43': 'ブースト（10分間）×3　　14.07%',
    'ruleText44': '食料×10000　　　14.07%',
    'ruleText45': '木材×10000　　　14.07%',
    'ruleText46': '鋼材×2000　　　14.07%',
    'ruleText47': 'ガス×500　　14.07%',
    'ruleText48': 'コミュニティ一覧',
    'ruleText49': 'Twitter：https://twitter.com/37games_pnsjp',
    'ruleText50': 'Discord：https://discord.com/invite/puzzlesandsurvival',
    'ruleText51': 'このイベントの最終解釈権は運営チームに属します。',
  },
  'ko-kr': {
    'title': '신공을 받고 전설이 되어라',
    'keyWords': '신공을 받고 전설이 되어라',
    'description': '신공을 받고 전설이 되어라',
    'website': '공식 사이트 입장',
    'download': '다운로드',
    'menuTab1': '신공 수령',
    'menuTab2': '파티 결성',
    'menuTab3': '아이템 추첨',
    'activityRule': '이벤트 규칙',
    'slogan': '신공을 받고 전설이 되어라',
    'time': '이벤트 기간: 2023년 9월 4일 09:00 ~ 2023년 9월 30일 23：59 (UTC)',
    'login': '[로그인]',
    'logout': '[계정 교체]',
    'bind': '[캐릭터 연동]',
    'bookName1': '태극권',
    'bookName2': '달마검',
    'bookName3': '역근경',
    'bookName4': '순양검',
    'bookName5': '금종조',
    'bookName6': '참마검',
    'bookName7': '분근좌골수',
    'bookName8': '당랑조',
    'bookName9': '잉좌공',
    'bookName10': '팔괘도',
    'bookName11': '봉화곤',
    'bookName12': '대안공',
    'bookIntroduction1': '「음과 양은 조화를 이루고 무궁무진한 변화를 일으킨다」',
    'bookIntroduction2': '「잡념에서 벗어나고 수련에 집중한다」',
    'bookIntroduction3': '「근골을 튼튼하게 하고 경락의 기 흐름을 원활하게 한다 」',
    'bookIntroduction4': '「괘상을 살펴보아 오행 변화의 근본을 파헤친다」',
    'bookIntroduction5': '「쇠로 된 종으로 몸을 감싸는 듯 상대를 막아낸다」',
    'bookIntroduction6': '「손바닥으로 돌을 쪼개고 쇠를 자른다」',
    'bookIntroduction7': '「신경을 압박으로 적이 관절을 움직이지 못하게 한다」',
    'bookIntroduction8': '「사마귀의 사냥 움직임을 본따 만들었으며, 부드러움 속에 강함이 있다」',
    'bookIntroduction9': '「손가락이 매의 발톱처럼 상대의 가슴을 파고들 수 있다」',
    'bookIntroduction10': '「연속되는 동작이 마치 물이 끊임없이 흘러가는 듯 변화가 무쌍하다」',
    'bookIntroduction11': '「파도 속에서 부침하는 듯 곤을 휘둘러 적을 찌른다」',
    'bookIntroduction12': '「강함과 부드러움이 공존하며 느림과 빠름이 조화를 이룬다」',
    'bookTag1': '무당',
    'bookTag2': '소림',
    'bookTag3': '쿤룬',
    'bookPageInfo': '\${page1} 권<br>\${page2} 장<br>\${page3} 절',
    'weaponName1': '괴',
    'weaponName2': '간',
    'weaponName3': '도끼',
    'weaponName4': '극',
    'weaponName5': '도',
    'weaponName6': '목인장',
    'weaponName7': '쌍절곤',
    'weaponName8': '창',
    'weaponName9': '추',
    'weaponName10': '월',
    'weaponName11': '비도',
    'weaponName12': '궁',
    'weaponName13': '구',
    'weaponName14': '낭아봉',
    'weaponName15': '사모',
    'weaponName16': '팔참도',
    'surplusBookChance': '남은 추첨 횟수: ',
    'lotteryBook': '공법 추첨',
    'getMore': '더 보기',
    'getMoreTip': '파티 결성 이벤트에 참여하고 공법 추첨 기회를 획득하세요!',
    'partTitle1': '공법 책갈피 맞춤제작',
    'partTitle2': '파티 결성',
    'partTitle3': '아이템 추첨',
    'partTitle4': '「퍼즐 오브 Z」을 다운로드받아 체험해보세요!',
    'saveShareText': '저장 후 공유',
    'tabText1': '공법',
    'tabText2': '책갈피',
    'tabText3': '영웅',
    'tabText4': '무기',
    'myTeam': '내 파티: ',
    'teamState1': '미가입',
    'teamState2': '\${teamNum} 명 가입 완료',
    'teamState3': '초대 성공!',
    'createTeam': '파티 생성',
    'addTeam': '파티 가입',
    'cipherInputTip': '암호를 입력해 파티에 가입하세요',
    'cipherLabel': '암호:',
    'linkLabel': '초대 링크:',
    'goInvite': '초대하기',
    'copyText': '복사',
    'concludeTip': '계속해서 더 많은 지휘관을 초대하세요!',
    'concludeLabel': '초대 성공 보상',
    'getState1': '미달성',
    'getState2': '수령',
    'getState3': '수령 완료',
    'getState4': '중복 달성 가능',
    'seeAward': '보상 확인',
    'awardBag': '보상 가방',
    'lotteryText': '추첨',
    'surplusSkinChance': '남은 추첨 기회: ',
    'awardName1': '스킨 조각*10',
    'awardName2': '강화 선택 보급 상자*5',
    'awardName3': '승성 선택 보급 상자*5',
    'awardName4': '정밀 승성 선택 보급 상자*3',
    'awardName5': '다이아*100',
    'awardName6': '항혈청 1,000',
    'awardName7': '10분 가속*3',
    'awardName8': '식량 10K',
    'awardName9': '목재 10K',
    'awardName10': '강철 2K',
    'awardName11': '휘발유 500',
    'popupShareTitle': '신공 공유',
    'popupShareTip': '파티에 가입해야 공유 보상을 획득할 수 있습니다.',
    'popupShareTipBtn1': '[파티 생성]',
    'popupShareTipBtn2': '[파티 가입]',
    'saveImg': '이미지 저장',
    'copyShare': '복사하고 공유하기',
    'copyShareTip': '초대 정보를 복사하였습니다. 친구를 초대해 더 많은 보상을 획득하세요',
    'copyShareText': '나의 쿵푸 파티에 합류해 신공을 수령하자!(암호: \${cipher}). 터치하여 신공 수령: ',
    'taskText1': '전용 공법 수령:',
    'taskText2': '신공 공유:',
    'taskText3': '지휘관 초대에 성공 시마다:',
    'taskText4': '파티 인원수 2명 달성:',
    'taskText5': '파티 인원수 3명 달성:',
    'taskText6': '파티 인원수 4명 달성:',
    'taskAward1': '추첨 기회*2',
    'taskAward2': '100다이아',
    'taskAward3': '추첨 기회*2',
    'taskTip1': '공법을 저장하면 수령에 성공합니다.',
    'taskTip2': '상대방이 이벤트 사이트에 로그인하고 신공을 수령해야 합니다.',
    'popupGetBookTitle': '공법 획득',
    'bookGrade1': 'S(전설) 공법',
    'bookGrade2': 'A(에픽) 공법',
    'bookGrade3': 'B(희귀) 공법',
    'popupBindTitle': '캐릭터 선택',
    'pServer': '서버 선택',
    'pRole': '캐릭터를 선택하세요',
    'bindPopupBtn1': '확인',
    'bindPopupBtn2': '취소',
    'pLogin': '로그인하세요',
    'noRole': '게임 캐릭터가 없으면',
    'popupInviteTitle': '지휘관 초대',
    'popupInviteTip': '',
    'popupFullTitle': '파티 인원 상한 도달',
    'popupFullTip': '커뮤니티에서 더 많은 쿵푸 파티를 찾으세요',
    'popupQuitTitle': '파티 탈퇴',
    'popupQuitTip1': '파티 탈퇴 후 다른 파티에 재가입할 수 있습니다',
    'popupQuitTip2': '* 보상은 계정 당 1회만 수령할 수 있으며 중복 획득이 불가능합니다.',
    'noBook': '공법 추첨을 터치해 신공을 수령하세요',
    'getPopupBtn2': 'Facebook에 공유',
    'getPopupBtn3': 'Discord에 공유',
    'getPopupBtn4': 'Twitter에 공유',
    'getPopupBtn5': 'Naver에 공유',
    'serviceText': '서비스 약관',
    'privicyText': '개인정보 취급 방침',
    'popupTip1': '캐릭터를 선택하세요.',
    'fbText': '나의 쿵푸 파티에 합류해 신공을 수령하자!(암호: \${cipher}).',

    'errTip1': '조작 실패. 잠시 후 다시 시도하거나 고객센터에 문의하세요.',
    'errTip2': '조작이 잦습니다. 다시 시도해 주세요.',
    'errTip3': '지급 완료',
    'errTip4': '보상 지급 실패. 잠시 후 다시 시도하거나 고객센터에 문의하세요.',
    'errTip5': '파라미터 오류. 다시 시도해 주세요.',
    'errTip6': '남은 추첨 횟수 부족',
    'errTip7': '암호를 정확하게 입력하세요',
    'errTip8': '암호 유효기간 만료. 커뮤니티에서 다른 파티를 구하세요',
    'errTip9': '파티 인원 상한 도달. 커뮤니티에서 다른 파티를 구하세요',
    'errTip10': '수령 조건 미달',
    'errTip11': '이미 해당 보상을 수령했습니다',
    'errTip12': '이벤트가 종료되었습니다',

    'ruleMainTitle': '「정상 도전」 이벤트가 시작됐습니다!',
    'ruleSubTitle': '이벤트에 참여해 신공과 다양한 보상을 받아가세요!',
    'ruleText1': '이벤트 시간:',
    'ruleText2': '2023년 9월 4일 09:00 ~ 2023년 9월 30일 23：59 (UTC)',
    'ruleText3': '이벤트 규칙:',
    'ruleText4': '1. 이벤트 기간 동안 이벤트 사이트에 방문해 전용 신공 공법을 수령하세요.',
    'ruleText5': '2. 전용 신공은 추첨을 통해 획득할 수 있습니다. 이벤트 사이트에 로그인하면 공법 추첨 기회 10회가 주어집니다. 공법 초고는 전설(금색), 에픽(자색)과 희귀(남색) 3가지로 나뉩니다.',
    'ruleText6': '3. 수령한 공법 초고에 유일한 ‘권, 장, 절’ 정보가 생성되고 해당 정보는 유저가 선택한 공법의 변경에 따라 변경되지 않습니다.',
    'ruleText7': '4. 이벤트 퀘스트를 깨면 최대 40회의 공법 추첨 기회 및 최소 30회의 아이템 추첨 기회를 얻을 수 있습니다.',
    'ruleText8': '5. 수령한 공법 초고 이미지를 사용해 커뮤니티와 게임 내 보상 추첨 이벤트에 참여할 수 있습니다. 보상 추첨 식별 정보는 수령한 공법의 ‘권, 장, 절’ 등에 의해 결정됩니다.',
    'ruleText9': '6. 자신만의 공법 초고를 가지고 커뮤니티 추첨 이벤트에도 참여할 수 있습니다. 게임 내 보상 추첨은 공법을 성공적으로 수령한 유저를 대상으로 진행합니다.',
    'ruleText10': '* 커뮤니티 이벤트 참여 링크는 맨 하단 내용을 참고하세요.',
    'ruleText11': '유의사항:',
    'ruleText12': '1. 커뮤니티와 게임 내 보상 추첨 결과 발표는 9월 30일(UTC)까지 해당 이벤트를 게시한 공식 커뮤니티와 게임 공지를 통해 진행합니다.',
    'ruleText13': '2. 당첨자는 추첨 결과 발표일부터 15일 안으로 운영진과 연락해 당첨자 정보를 작성해야 합니다. 제때에 당첨자 정보를 작성하지 않으면 보상 포기로 간주합니다.',
    'ruleText14': '3. 유저 1명당 하나의 계정으로 이벤트에 참여하고 보상을 수령할 수 있습니다.',
    'ruleText15': '4. 로그인하지 않은 상태에서 뽑은 공법은 로그인하면 초기화되므로 반드시 로그인하고 공법 추첨을 진행하세요.',
    'ruleText16': '5. 유저가 파티를 탈퇴하면 퀘스트 진행도가 초기화되므로 퀘스트 조건을 달성하면 제때에 보상을 수령하세요.',
    'ruleText17': '6. 이벤트 참여 계정과 보상 수령 계정은 동일한 계정이어야 합니다.',
    'ruleText18': '이벤트 상품:',
    'ruleText19': '1. 게임 내 보상 추첨(전서버 1명): ‘무술대가’ 버전 시리즈 아이템(영구 피난소 스킨*1, 테마 명패*1, 테마 프레임*1, 테마 우편지*1)',
    'ruleText20': '2. 커뮤니티 보상 추첨(전서버 30명): 10달러 상당의 키프트 카드',
    'ruleText21': '3. 커뮤니티 공유 보상: 100다이아. 공법 수령 및 공유 첫 완료 시 수령할 수 있습니다.',
    'ruleText22': '확률:',
    'ruleText23': '1. 공법 추첨 확률:',
    'ruleText24': '(S 전설 공법) 태극권: 3.40%',
    'ruleText25': '(S 전설 공법) 달마검: 3.30%',
    'ruleText26': '(S 전설 공법) 역근경: 3.30%',
    'ruleText27': '(A 전설 공법) 순양검: 7.50%',
    'ruleText28': '(A 전설 공법) 금종조: 7.50%',
    'ruleText29': '(A 전설 공법) 참마검: 7.50%',
    'ruleText30': '(A 전설 공법) 분근좌골수: 7.50%',
    'ruleText31': '(B 희귀 공법) 당랑조: 12%',
    'ruleText32': '(B 희귀 공법) 잉좌공: 12%',
    'ruleText33': '(B 희귀 공법) 팔괘도: 12%',
    'ruleText34': '(B 희귀 공법) 봉화곤: 12%',
    'ruleText35': '(B 희귀 공법) 대안공: 12%',
    'ruleText36': '2. 아이템 추첨 확률:',
    'ruleText37': '스킨 조각*10: 0.60%',
    'ruleText38': '강화 선택 보급 상자*5: 1.66%',
    'ruleText39': '승성 선택 보급 상자*5: 1.66%',
    'ruleText40': '정밀 승성 선택 보급 상자*3: 1.66%',
    'ruleText41': '다이아*100: 10%',
    'ruleText42': '항혈청 1,000: 14.07%',
    'ruleText43': '10분 가속*3: 14.07%',
    'ruleText44': '식량 10K: 14.07%',
    'ruleText45': '목재 10K: 14.07%',
    'ruleText46': '강철 2K: 14.07%',
    'ruleText47': '휘발유 500: 14.07%',
    'ruleText48': '커뮤니티:',
    'ruleText49': 'Facebook：https://www.facebook.com/puzzleofZ.KR/ <br> Discord：https://discord.com/invite/puzzlesandsurvival',
    'ruleText50': 'Lounge：https://game.naver.com/lounge/puzzle_of_Z',
    'ruleText51': '이벤트 최종 해석권은 운영진에 있습니다.',
  },
}